import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import Box from '../../Box';
let ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
  };
  _proto.render = function render() {
    const {
      children
    } = this.props;
    const {
      error,
      errorInfo
    } = this.state;
    if (errorInfo) {
      return /*#__PURE__*/React.createElement(Box, {
        p: 6
      }, /*#__PURE__*/React.createElement("h1", null, "Something went wrong."), /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement(Box, {
        as: "pre",
        color: "error",
        pt: 5
      }, error && error.toString(), errorInfo.componentStack)));
    }
    return children;
  };
  return ErrorBoundary;
}(React.Component);
export default ErrorBoundary;